import SurveyStepPeriodeContainer from "./SurveyStepPeriodeContainer"
export default SurveyStepPeriodeContainer


// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepPeriode/index.js